<template>
  <div class="container">
    <!-- 头部 -->
    <div class="headBox" :style="cssVars">
      <!-- 面包屑 -->
      <div class="flex flex-pack-justify head">
        <div class="breadcrumbs">
          <div class="flex flex-align-center">
            <i class="soccerIcon icon-font icon-fan"></i>
            <span
              >{{langConfig.leagues[langConfig.curLang]['FOOTBALL']}}&nbsp;&nbsp;>&nbsp;&nbsp;{{langConfig.leagues[langConfig.curLang]['LEAGUES']}}&nbsp;&nbsp;>&nbsp;&nbsp;</span
            >
          </div>
        </div>
        <div class="flex" v-if="leagueInfo.seasonList.length">
          <div class="m-season" @click="showSeasonPopup = true">
            {{
              leagueInfo.seasonList.length
                ? leagueInfo.seasonList.find(
                    (item) => item.seasonValue == season
                  )["seasonkey"]
                : ""
            }}
          </div>
          <div class="m-league" @click="showLeaguePopup = true">
            {{langConfig.leagues[langConfig.curLang]['ALL_LEAGUES']}}
          </div>
          <el-select
            v-model="season"
            placeholder="请选择"
            @change="seasonChange"
            :popper-append-to-body="false"
          >
            <el-option
              v-for="item in leagueInfo.seasonList"
              :key="item.seasonkey"
              :label="item.seasonkey"
              :value="item.seasonValue"
            >
            </el-option>
          </el-select>
        </div>
      </div>
      <!-- info -->
      <div class="flex flex-pack-justify flex-align-center">
        <div class="flex flex-align-center">
          <div class="logo">
            <img
              :src="common.leagueImgGet(leagueInfo.league.id)"
              @error="common.imgError($event, 'team')"
            />
          </div>
          <div class="flex flex-v">
            <div class="title">
              <span
                :class="
                  leagueInfo.league &&
                  leagueInfo.league.fullName &&
                  leagueInfo.league.fullName.length >= 28
                    ? 'short'
                    : ''
                "
                >{{ leagueInfo.league.fullName }}</span
              >
            </div>
            <div class="flex flex-align-center" v-if="leagueInfo.country.name">
              <img
                class="country-flag"
                :src="common.countryDataImgGet(leagueInfo.country.id)"
                @error="common.imgError($event, 'country')"
              />
              <span class="country">{{ leagueInfo.country.name }}</span>
            </div>
          </div>
        </div>
        <div
          class="focus"
          v-if="leagueInfo.league.fullName || leagueInfo.league.shortName"
        >
          <i
            class="collectStarIcon icon-font icon-collectStar"
            :class="isFollow ? 'isFollow' : ''"
            @click="followLeague(leagueInfo.league.id)"
          ></i>
        </div>
      </div>
    </div>
    <!-- season弹窗 -->
    <van-popup
      v-model="showSeasonPopup"
      position="bottom"
      :style="{
        backgroundColor: '#F5F5F5',
        borderTopLeftRadius: '0.2rem',
        borderTopRightRadius: '0.2rem',
      }"
      get-container="#app"
    >
      <div class="mSeasonWarp" v-if="showSeasonPopup">
        <ul class="seasonList">
          <li
            v-for="item in leagueInfo.seasonList"
            :key="item.id"
            :class="item.seasonValue == season ? 'active' : ''"
            @click="
              season = item.seasonValue;
              showSeasonPopup = false;
              seasonChange(item.seasonValue);
            "
          >
            {{ item.seasonkey }}
          </li>
        </ul>
        <div class="cancel" @click="showSeasonPopup = false">Cancel</div>
      </div>
    </van-popup>
    <!-- all league弹窗 -->
    <van-popup
      v-model="showLeaguePopup"
      position="bottom"
      :style="{
        height: '93%',
        borderTopLeftRadius: '0.2rem',
        borderTopRightRadius: '0.2rem',
      }"
      get-container="#app"
    >
      <AllLeagues
        :list="leagueList"
        @leagueChange="onLeagueChange"
        @close="showLeaguePopup = false"
      />
    </van-popup>
  </div>
</template>
<script>
import AllLeagues from "./allLeagues";
export default {
  props: ["leagueInfo", "leagueList"],
  components: {
    AllLeagues,
  },
  data() {
    return {
      isFollow: false,
      season: "",
      searchKey: "",
      selected: [],
      showLeaguePopup: false,
      showSeasonPopup: false,
    };
  },
  computed: {
    cssVars() {
      return {
        "--color":
          "#" + (this.leagueInfo.league?.color ?? "FF6915").replace("#", ""),
      };
    },
  },
  methods: {
    seasonChange(value) {
      this.season = value;
      this.$emit("onSeasonChange", value);
    },
    countrySearch(e) {
      this.searchKey = e.target.value;
      this.selected = [];
    },
    onLeagueChange(country, league) {
      this.showLeaguePopup = false;
      this.$emit("leagueChange", country, league);
    },
    // 联赛关注
    followLeague(leagueId) {
      let _param = {
        leagueId,
        operation: 1,
      };

      if (this.isFollow) {
        _param.operation = 2;
      }

      _param.callback = (res) => {
        if (res.state == 403) {
          // 未登录
          this.$emit("onChangLogin", {
            loginShow: true,
          });
        }
        if (res.state == 200) {
          if (_param.operation == 2) {
            this.$message({
              dangerouslyUseHTMLString: true,
              message: this.langConfig.index[this.langConfig.curLang]['REMOVED_MY_LEAGUES'],
              type: "success",
              iconClass: "icon-font event-fav favDelIcon",
              customClass: "favSuccess",
              //offset: (document.documentElement.clientHeight - 50),
              duration: 5000,
            });
            this.isFollow = false;
          } else {
            this.$message({
              dangerouslyUseHTMLString: true,
              message: this.langConfig.index[this.langConfig.curLang]['ADD_MY_LEAGUES'],
              type: "success",
              iconClass: "icon-font icon-collectStar favSuccessIcon",
              customClass: "favSuccess",
              //offset: (document.documentElement.clientHeight - 50),
              duration: 5000,
            });
            this.isFollow = true;
          }
        }
      };

      this.common.followLeague(_param);
    },
  },
  created() {},
  watch: {
    "leagueInfo.seasonList": {
      deep: true,
      handler(value) {
        this.season = "";
      },
    },
    "leagueInfo.isFollow": {
      deep: true,
      handler(value) {
        this.isFollow = value;
      },
    },
  },
};
</script>
<style lang="less">
.container {
  .headBox {
    background: var(--color);
    padding: 8px 16px 16px 16px;

    .head {
      margin-bottom: 8px;
    }

    .breadcrumbs {
      .soccerIcon {
        font-size: 16px;
        color: @color_FFF;
        margin-right: 8px;
      }
      span {
        color: @color_FFF;
        font-size: 14px;
        font-family: @font_family_SF_Pro_Display;
      }
    }
    .m-league,
    .m-season {
      display: none;
    }
    .el-select {
      width: 109px;
    }
    .el-input__inner {
      height: 24px !important;
      line-height: 24px !important;
      padding: 0 0 0 8px;
    }
    .el-input__icon {
      height: 24px !important;
      line-height: 24px !important;
    }
    .el-input__suffix {
      right: 0;
    }

    .logo {
      border-radius: 50%;
      background: @color_FFF;
      width: 80px;
      height: 80px;
      margin-right: 8px;
      font-size: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      overflow: hidden;
      img {
        width: 40px;
        object-fit: contain;
      }
    }

    .focus {
      height: 32px;
      cursor: pointer;
    }

    .title {
      font-family: @font_family_SF_Pro_Display;
      font-size: 24px;
      color: @color_FFF;
      font-weight: bold;
      margin-bottom: 8px;
      display: inline-block;
    }
    .country-flag {
      width: 18px;
      height: 12px;
      margin-right: 8px;
    }
    .country {
      font-family: @font_family_SF_Pro_Display;
      font-size: 14px;
      color: @color_FFF;
    }
    .collectStarIcon {
      font-size: 32px;
      color: #d9d9d9;
      &.isFollow {
        color: @color_FFB23F;
      }
    }
  }
}
@media screen and (max-width: 767px) {
  .container {
    .headBox {
      width: 100%;
      padding: 0.08rem 0.12rem;
      .head {
        margin-bottom: 0.08rem;
      }
      .breadcrumbs {
        height: 0.2rem;
        line-height: 0.2rem;
        .soccerIcon {
          display: none;
          font-size: 0.16rem;
          margin-right: 0.08rem;
        }
        span {
          font-size: 0.14rem;
        }
      }
      .m-league,
      .m-season {
        display: block;
        font-size: 0.12rem;
        color: #fff;
        margin-left: 0.02rem;
        &::after {
          content: "";
          width: 0.14rem;
          height: 0.16rem;
          display: inline-block;
          vertical-align: middle;
          background: url("../../../assets/images/icon-down2.png") 0 0 / contain
            no-repeat;
        }
      }
      .el-select {
        display: none;
      }
      .logo {
        width: 0.56rem;
        height: 0.56rem;
        margin-right: 0.08rem;
        img {
          width: 0.4rem;
          height: 0.4rem;
        }
      }

      .focus {
        height: 0.32rem;
      }

      .title {
        font-size: 0.18rem;
        font-weight: bold;
        margin-bottom: 0.08rem;
        height: 0.2rem;
        .short {
          display: block;
          font-size: 0.15rem;
        }
      }
      .country-flag {
        width: 0.18rem;
        height: 0.12rem;
        margin-right: 0.08rem;
      }
      .country {
        font-size: 0.14rem;
      }
      .collectStarIcon {
        font-size: 0.32rem;
        display: block;
      }
    }

    .mLeagueWarp {
      padding: 0.24rem;
      h1 {
        font-size: 0.18rem;
        font-weight: 700;
        padding-bottom: 0.16rem;
      }
      .m-country-search {
        width: 3.27rem;
        height: 0.36rem;
        font-size: 0.14rem;
        border-radius: 1rem;
        background-color: #f5f5f5;
        padding-left: 0.44rem;
        position: relative;

        &::before {
          content: "";
          position: absolute;
          top: 0.08rem;
          left: 0.16rem;
          width: 0.2rem;
          height: 0.2rem;
          background: url("../../../assets/images/icon-search.png") 0 0 /
            contain no-repeat;
        }

        input {
          width: 100%;
          height: 0.36rem;
          border: 0;
          background-color: transparent;
        }
      }
    }
  }

  .mSeasonWarp {
    max-height: 3.9rem;
    .seasonList {
      max-height: 0.48rem * 7;
      overflow: auto;
      background-color: #fff;
      li {
        height: 0.48rem;
        line-height: 0.48rem;
        font-size: 0.16rem;
        color: #434343;
        text-align: center;
        &:not(:last-child) {
          border-bottom: 1px solid #f0f0f0;
        }
        &.active {
          color: @color_FF6915;
          font-weight: 700;
        }
      }
    }
    .cancel {
      color: #8c8c8c;
      background-color: #fff;
      height: 0.48rem;
      line-height: 0.48rem;
      text-align: center;
      margin-top: 0.06rem;
      font-size: 0.16rem;
    }
  }
}
</style>




// WEBPACK FOOTER //
// ./src/views/leagues/components/leagueInfo.vue